export const VALID_STATES = [
  'New York',
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico	',
  'North Carolina	',
  'North Dakota	',
  'Ohio	',
  'Oklahoma	',
  'Oregon	',
  'Pennsylvania	',
  'Puerto Rico	',
  'Rhode Island	',
  'South Carolina	',
  'South Dakota	',
  'Tennessee	',
  'Texas	',
  'Utah	',
  'Vermont	',
  'Virginia	',
  'Virgin Islands	',
  'Washington	',
  'West Virginia	',
  'Wisconsin	',
  'Wyoming	',
];

export const VALID_GRADES = Array.from({ length: 12 }, (_, i) => i + 1);

export const VALID_ULAD = ['УПН', 'УПЮ', 'УСП', 'УПС'];

export const VALID_STUPIN = [
  'Прихильник',
  'Орля',
  'Сильне орля',
  'Красне орля',
  'Обережне орля',
  'Бистре орля',
  'Розвідувач',
  'Розвідувачка',
  'Учасник 1',
  'Учасниця 1',
  'Учасник 2',
  'Учасниця 2',
  'Учасник 1',
  'Розвідувач',
  'Розвідувачка',
  'Ю2',
  'Братчик',
  'Сестричка',
  'Старша Пластунка',
  'Старший Пластун',
  'Пластун сеньор',
  'Пластунка сеньор',
];
